'use client';

import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface WizardContext {
  overlayContainer?: Element | null;
}

const WizardContext = createContext<WizardContext>({});

const useWizardContext = () => {
  return useContext(WizardContext);
};

const Wizard = ({ children }: PropsWithChildren) => {
  const [overlayContainer, setOverlayContainer] = useState<HTMLDivElement | null>(null);

  return (
    <div className="w-full max-w-[800px] relative rounded-[16px] border border-primary-200 p-[16px] md:p-[32px] overflow-hidden">
      <WizardContext.Provider value={{ overlayContainer }}>{children}</WizardContext.Provider>

      <div
        className="wizard__overlays absolute top-0 left-0 w-full h-full empty:hidden [&>*]:absolute [&>*]:top-0 [&>*]:left-0 [&>*]:w-full [&>*]:h-full"
        ref={setOverlayContainer}
      ></div>
    </div>
  );
};

export { Wizard, useWizardContext };
